import { render, staticRenderFns } from "./BrandSafety.vue?vue&type=template&id=2d24faf2&scoped=true&"
import script from "./BrandSafety.vue?vue&type=script&lang=js&"
export * from "./BrandSafety.vue?vue&type=script&lang=js&"
import style0 from "./BrandSafety.vue?vue&type=style&index=0&id=2d24faf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24faf2",
  null
  
)

export default component.exports